<template>
  <v-row class="ftc" align-content="center" justify="start">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn
          color="green"
          size="x-small"
          variant="plain"
          append-icon="mdi-plus"
          v-bind="props"
        >
          Definir Ator(es)
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Definir Atores do CSU </span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="atores"
                  :items="atoresProjNomes"
                  label="Atores*"
                  multiple
                ></v-select>
              </v-col>
            </v-row>
          </v-container>

          <small>*Campo obrigatório</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue-darken-1" variant="text" @click="submitForm">
            Salvar
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 * @module AtorCSU
 * @desc Modal para adicionar um ator em um determinado caso de uso.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o modal está visível.
 * @vue-data {string} idProjeto - O id do projeto.
 * @vue-data {Array.<Object>} [atores=[]] - Array com os objetos que
 * representam os atores.
 * @vue-data {Array.<Object>} [atoresProj=[]] - Array com os objetos que
 * representam os atores do projeto.
 * @vue-data {Array.<string>} [atoresProjNomes=[]] - Array com os nomes
 * dos atores do projeto.
 * @vue-data {Array.<string>} [atoresId=[]] - Array com os IDs
 * dos atores.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se a adição
 * do ator para o caso de uso ainda está sendo feita.
 */
import axios from 'axios';

import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  props: {
    id: Number,
  },
  emits: ['atorAdicionado'],
  data: () => ({
    dialog: false,
    idProjeto: null,
    atores: [],
    atoresProj: [],
    atoresProjNomes: [],
    atoresId: [],
    isLoading: false,
  }),
  created() {
    this.idProjeto = this.$route.params.idProjeto;
    this.fetchAtores(this.id);
    this.fetchAtoresProj(this.idProjeto);
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza uma requisição HTTP para obter os atores do caso de uso.
     *
     * @param {Number} id O id do caso de uso.
     */
    async fetchAtores(id) {
      try {
        const response = await axios.get(`${apiUrl}/api/v1/ator/${id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        });
        var atores = response.data.ator;
        atores.forEach((element) => {
          this.atores.push(element.nome_ator);
        });
        console.log(this.atores);
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Realiza uma requisição HTTP para obter os atores do projeto onde
     * o caso de uso está definido.
     *
     * @param {Number} id O id do caso de uso.
     */
    async fetchAtoresProj(id) {
      try {
        const response = await axios.get(
          `${apiUrl}/api/v1/ator/projeto/${id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.atoresProj = response.data.ator;
        this.atoresProjNomes = this.atoresProj.map((ator) => ator.nome_ator);
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Obtém uma lista com os IDs dos atores do projeto.
     */
    pegaIdAtores() {
      for (var i = 0; i < this.atores.length; i++) {
        for (var j = 0; j < this.atoresProj.length; j++) {
          if (this.atores[i] == this.atoresProj[j].nome_ator) {
            this.atoresId.push(this.atoresProj[j].id_ator);
          }
        }
      }
    },

    /**
     * Realiza uma requisição HTTP para adicionar um novo ator ao
     * caso de uso.
     */
    async submitForm() {
      this.isLoading = true;
      this.pegaIdAtores();
      const data = {
        atoresId: this.atoresId,
      };
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.post(
          `${apiUrl}/api/v1/ator/casouso/${this.id}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );

        this.$toast.success(response.data.msg);
        this.$emit('atorAdicionado', this.id);
        this.$router.push(`/projects/${this.idProjeto}/CasoUso/${this.id}`);
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.msg);
      } finally {
        this.dialog = false;
        this.isLoading = false;
        location.reload();
      }
    },
  },
};
</script>
<style scoped>
.ftc {
  width: fit-content;
}
</style>
